/**
 * Created by mykurisu on 2017/9/13.
 */
import React from 'react'
import {WKOwnDialog} from '../../components/wk'
import {isPC, isIos} from '../../utils'
import Play from '../../images/recorded/play2.png'
import Pause from '../../images/recorded/pause2.png'
import PreIcon from '../../images/recorded/Rewind.png'
import NextIcon from '../../images/recorded/FastForward.png'
import UnPlay from '../../images/recorded/un-play.png'
import UnPreIcon from '../../images/recorded/un-pre.png'
import UnNextIcon from '../../images/recorded/un-next.png'
import SingleIcon from '../../images/recorded/single.png'
import LoopIcon from '../../images/recorded/loop.png'
import Loading from '../../images/recorded/loading.png'


class AudioBar extends React.Component {

    constructor (){
        super();
        this.offsetWindowLeft = 0;
        this.flow = 0
        this.isIos = true
        this.mousing = false
        this.state = {
            canPlay: true,
            isPlaying: false,
            isLooping: false,
            bufferedPercent: 0,
            currentTime: 0,
            currentTotalTime: 0,
            startX: 0,
            moveX: 0,
            showTips: false,
            showLoading: true,
            //回放
            has_currentTime_dialog: false,
            has_currentTime: false,
            has_currentTime_buttons: [
                {
                    label: '取消',
                    type: 'default',
                    onClick: () => this.handleHasCtDontPlay()
                },
                {
                    label: '好的',
                    onClick: () => this.handleHasCtPlay()
                }
            ]
        }
    }

    componentDidMount() {
        new Image().src = Loading
        this.offsetWindowLeft = this.audioProgress.getBoundingClientRect().left;
        this.isIos = isIos()
        if (this.props.audioInfo.audio_url !== ''){

            if (isPC()){
                this.initListenClick();
                // this.progressBar.addEventListener('mousedown', (e) => this.mouseDown(e),false)
            }else {
                this.initListenTouch();
            }

            this.lectureAudio.src = this.props.audioInfo.audio_url;

            if(this.lectureAudio && !isNaN(this.lectureAudio.duration)) {
                this.setState({
                    currentTotalTime: this.lectureAudio.duration
                });
            }

            if (window.localStorage.getItem(this.props.lecture_id) > 5){
                this.setState({
                    has_currentTime: true,
                    has_currentTime_dialog: true
                })
            }
        }
    }

    componentWillUnmount() {
        this.touchendPlay && clearTimeout(this.touchendPlay);
        this.buffered && clearInterval(this.buffered);
        this.ShowTips && clearTimeout(this.ShowTips);
        this.StoreCurrentTime && clearInterval(this.StoreCurrentTime);
    }

    handleHasCtPlay() {
        this.setState({
            currentTime: Number(window.localStorage.getItem(this.props.lecture_id)),
            has_currentTime_dialog: false
        }, () => {
            this.handleAudioPlay();
        });
    }

    handleHasCtDontPlay() {
        this.setState({
            has_currentTime: false,
            has_currentTime_dialog: false
        }, () => {
            this.lectureAudio.currentTime = 0
            window.localStorage.removeItem(this.props.lecture_id)
        });
    }

    handleAudioCanplay() {
        this.initAudioStatus();
    }

    initAudioStatus() {
        if (this.props.canIListen && this.lectureAudio){
            if(this.lectureAudio && !isNaN(this.lectureAudio.duration)) {
                let x = this.lectureAudio.duration / this.progressBar.clientWidth;
                this.setState({
                    canPlay: true,
                    moveX: x,
                    currentTotalTime: this.lectureAudio.duration
                });
                //this.handleAudioPlay();
            }
        }
    }

    handleAudioPlay() {
        if (this.state.canPlay){
            if (this.lectureAudio){
                this.lectureAudio.play();
                this.setState({
                    isPlaying: true
                });
                this.StoreCurrentTime = setInterval(() => {
                    window.localStorage.setItem(this.props.lecture_id, this.state.currentTime)
                }, 500);
            }
        }
    }

    handleTimeUpdate() {
        if (this.isIos) {
            this.flow ++
            if (this.flow % 5 !== 0) {
                return
            }
        }
        if (this.state.showLoading) {
            this.setState({
                showLoading: false
            })
        }
        if (this.state.has_currentTime){
            this.lectureAudio.currentTime = Number(window.localStorage.getItem(this.props.lecture_id));
            this.setState({
                has_currentTime: false,
            })
        }

        this.setState({
            currentTime: (this.lectureAudio.currentTime < (this.state.currentTotalTime - 1)) ? this.lectureAudio.currentTime : this.state.currentTotalTime
        });

    }

    handlePlayType() {
        if (this.state.isLooping){
            this.setState({
                currentTime: 0
            }, () => {
                this.lectureAudio.currentTime = this.state.currentTime;
                this.lectureAudio.play();
            })
        }else {
            if (this.props.audioInfo.next_lecture_id && this.state.currentTime !== 0){
                this.handleAudioPause();
                window.localStorage.removeItem(this.props.lecture_id);
                this.handleNextLecture();
            }else {
                this.handleAudioPause();
            }
        }
    }

    handleAudioPause() {
        this.lectureAudio.pause();
        this.setState({
            isPlaying: false
        });
        this.StoreCurrentTime && clearInterval(this.StoreCurrentTime);
    }

    handleLoop() {
        this.ShowTips && clearTimeout(this.ShowTips);
        if (this.state.isLooping){
            this.setState({
                isLooping: false,
                showTips: true
            })
        }else {
            this.setState({
                isLooping: true,
                showTips: true
            });
        }
        this.ShowTips = setTimeout(() => {
            this.setState({
                showTips: false
            })
        }, 1500)
    }

    initListenTouch() {
        this.audioPoint.addEventListener('touchstart', (e) => this.pointStart(e), false);
        this.audioPoint.addEventListener('touchmove', (e) => this.pointMove(e), false);
        this.audioPoint.addEventListener('touchend', (e) => this.pointEnd(e), false);
    }

    initListenClick() {
        this.audioPoint.addEventListener('mousedown', (e) => this.pointStartM(e), false);
        document.body.addEventListener('mousemove', (e) => this.pointMoveM(e), false);
        document.body.addEventListener('mouseup', (e) => this.pointEndM(e), false);
    }

    pointStartM(e) {
        this.mousing = true
        e.preventDefault();
        let touch = e;
        this.lectureAudio.pause();
        this.setState({
            isPlaying: false,
            startX: touch.pageX
        });
    }

    pointMoveM(e) {
        if (!this.mousing) {
            return
        }
        e.preventDefault();
        let touch = e;
        let x = touch.pageX - this.state.startX; //滑动的距离
        let maxMove = this.progressBar.clientWidth;

        if (x >= 0){
            if (x + this.state.startX - this.offsetWindowLeft >= maxMove){
                this.setState({
                    currentTime: this.state.currentTotalTime,
                }, () => {
                    this.lectureAudio.currentTime = Math.floor(this.state.currentTime);
                })
            }else {
                this.setState({
                    currentTime: (x + this.state.startX - this.offsetWindowLeft) * this.state.moveX
                }, () => {
                    this.lectureAudio.currentTime = Math.floor(this.state.currentTime);
                })
            }
        }else {
            if (-x <= this.state.startX - this.offsetWindowLeft){
                this.setState({
                    currentTime: (this.state.startX + x - this.offsetWindowLeft) * this.state.moveX,
                }, () => {
                    this.lectureAudio.currentTime = Math.floor(this.state.currentTime);
                })
            }else {
                this.setState({
                    currentTime: 0
                }, () => {
                    this.lectureAudio.currentTime = Math.floor(this.state.currentTime);
                })
            }
        }
    }

    pointEndM(e) {
        if (!this.mousing) {
            return
        }
        this.mousing = false
        e.preventDefault();
        if (this.state.currentTime < this.state.currentTotalTime){
            this.touchendPlay = setTimeout(() => {
                this.handleAudioPlay();
            }, 300)
            //this.handleAudioPlay();
        }
    }

    pointStart(e) {
        e.preventDefault();
        let touch = e.touches[0];
        this.lectureAudio.pause();
        this.setState({
            isPlaying: false,
            startX: touch.pageX
        });
    }

    pointMove(e) {
        e.preventDefault();
        let touch = e.touches[0];
        let x = touch.pageX - this.state.startX; //滑动的距离
        let maxMove = this.progressBar.clientWidth;

        if (x >= 0){
            if (x + this.state.startX - this.offsetWindowLeft >= maxMove){
                this.setState({
                    currentTime: this.state.currentTotalTime,
                }, () => {
                    this.lectureAudio.currentTime = Math.floor(this.state.currentTime);
                })
            }else {
                this.setState({
                    currentTime: (x + this.state.startX - this.offsetWindowLeft) * this.state.moveX
                }, () => {
                    this.lectureAudio.currentTime =  Math.floor(this.state.currentTime);
                })
            }
        }else {
            if (-x <= this.state.startX - this.offsetWindowLeft){
                this.setState({
                    currentTime: (this.state.startX + x - this.offsetWindowLeft) * this.state.moveX,
                }, () => {
                    this.lectureAudio.currentTime =  Math.floor(this.state.currentTime);
                })
            }else {
                this.setState({
                    currentTime: 0
                }, () => {
                    this.lectureAudio.currentTime =  Math.floor(this.state.currentTime);
                })
            }
        }
    }

    pointEnd(e) {
        e.preventDefault();
        if (this.state.currentTime < this.state.currentTotalTime){
            this.touchendPlay = setTimeout(() => {
                this.handleAudioPlay();
            }, 300)
            //this.handleAudioPlay();
        }
    }

    mouseDown(e) {
        this.setState({
            currentTime: (e.clientX - this.offsetWindowLeft) * this.state.moveX
        }, () => {
            this.lectureAudio.currentTime = this.state.currentTime;
        })
    }

    renderPlayTime(time) {
        let min = time / 60;
        let minutes = parseInt(min, 10);
        if (minutes < 10){
            minutes = '0' + minutes
        }
        let sec = time % 60;
        let seconds = parseInt(sec, 10);
        if (seconds < 10){
            seconds = '0' + seconds;
        }
        return minutes + ':' + seconds
    }

    handlePreLecture() {
        window.location.href = `/lecture/${this.props.audioInfo.prev_lecture_id}`
    }

    handleNextLecture() {
        window.location.href = `/lecture/${this.props.audioInfo.next_lecture_id}`
    }

    render() {
        const {isPlaying, showLoading, isLooping, currentTime, currentTotalTime, bufferedPercent, showTips} = this.state;
        const left = isNaN(currentTime/currentTotalTime) ? -18 : currentTime/currentTotalTime * (this.progressBar && this.progressBar.clientWidth) - 18;
        const pointStyle = {transform: `translate3d(${left}px, 0, 0)`, WebKetTransform: `translate3d(${left}px, 0, 0)`}

        if (this.props.canIListen && this.props.audioInfo.audio_url === '') {
            return null
        }

        return (
            <div className={`recorded-audio ${isPlaying ? 'is-playing' : ''}`} onClick={this.props.canIListen ? null : () => this.props.payMethod()}>

                <WKOwnDialog title="温馨提示" show={this.state.has_currentTime_dialog} buttons={this.state.has_currentTime_buttons}>
                    是否回到上次播放的进度？
                </WKOwnDialog>

                <div className="audio-looping" style={{opacity: showTips ? '0.8' : '0'}}>
                    {isLooping ? '循环播放' : '列表播放'}
                </div>
                {this.props.audioInfo.audio_url !== '' &&
                <audio preload="metadata"
                       src={this.props.audioInfo.audio_url}
                       ref={(audio) => {this.lectureAudio = audio}}
                       style={{width: '1px', height: '1px', visibility: 'hidden'}}
                       onCanPlay={() => this.handleAudioCanplay()}
                       onTimeUpdate={() => this.handleTimeUpdate()}
                       onEnded={() => this.handlePlayType()}
                >
                </audio>
                }
                <div className="audio-progress" ref={(r) => {this.audioProgress = r}}>
                    <div className="audio-progress-bar" ref={(bar) => {this.progressBar = bar}}>
                        <div className="audio-progress-bar-preload" style={{width: bufferedPercent + '%'}}></div>
                        <div className="audio-progress-bar-current" style={{width: `calc(${currentTime}/${currentTotalTime} * ${this.progressBar && this.progressBar.clientWidth}px)`}}></div>
                    </div>
                    <div className="audio-progress-point-area" ref={(point) => {this.audioPoint = point}} style={pointStyle}>
                        <div className="audio-progress-point">

                        </div>
                    </div>
                </div>
                <div className="audio-timer">
                    <p className='start-time'>{this.renderPlayTime(currentTime)}</p>
                    <p className='end-time'>{this.renderPlayTime(currentTotalTime)}</p>
                </div>

                {(this.props.canIListen && this.props.audioInfo.audio_url !== '') ?
                <div className="audio-control">
                    {/* {!this.props.isMinaApp &&
                    <div className="audio-control-pre" onClick={this.props.audioInfo.prev_lecture_id ? () => this.handlePreLecture() : null}>
                        <img src={this.props.audioInfo.prev_lecture_id ? PreIcon : UnPreIcon} alt=""/>
                    </div>
                    } */}
                    {/*{this.state.showLoading ?
                        <div className="audio-control-loading">
                            <img src={Loading} alt=""/>
                        </div>
                        :
                        <div className="audio-control-play"
                             onClick={() => isPlaying ? this.handleAudioPause() : this.handleAudioPlay()}>
                            <img src={isPlaying ? Pause : Play} alt=""/>
                        </div>
                    }*/}
                    {isPlaying ?
                        <div className={showLoading ? "audio-control-loading" : "audio-control-play"} onClick={showLoading ? null : () => this.handleAudioPause()}>
                            <img src={showLoading ? Loading : Pause} alt=""/>
                        </div>
                        :
                        <div className="audio-control-play"
                             onClick={() => this.handleAudioPlay()}>
                            <img src={Play} alt=""/>
                        </div>
                    }
                    {/* {!this.props.isMinaApp &&
                    <div className="audio-control-next" onClick={this.props.audioInfo.next_lecture_id ? () => this.handleNextLecture() : null}>
                        <img src={this.props.audioInfo.next_lecture_id ? NextIcon : UnNextIcon} alt=""/>
                    </div>
                    }
                    {!this.props.isMinaApp &&
                    <div className="audio-control-type" onClick={() => this.handleLoop()}>
                        <img src={isLooping ? LoopIcon : SingleIcon} alt=""/>
                    </div>
                    } */}
                </div>
                    :
                    <div className="audio-control">
                        {/* <div className="audio-control-pre">
                            <img src={UnPreIcon} alt=""/>
                        </div> */}
                        <div className="audio-control-play">
                            <img src={Play} alt=""/>
                        </div>
                        {/* <div className="audio-control-next">
                            <img src={UnNextIcon} alt=""/>
                        </div> */}
                    </div>
                }

            </div>
        )
    }
}

export default AudioBar


// WEBPACK FOOTER //
// ./src/pages/recordedPage/AudioBar.js